import React from 'react';
import { htmlEditorHelperActions } from 'src/components/10-atoms/form/inputs/editor/html/HTMLEditor/useHTMLEditor';
import { promptHelperActions } from 'src/components/20-helper-views/prompt/helperActions';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import { useCreateEFMutation } from 'src/modules/exam-preparation/graphql/ef/create';
import { useUpdateEFMutation } from 'src/modules/exam-preparation/graphql/ef/update';
import useI18n from 'src/modules/translations/hooks/useI18n';
import EFView from './EFView';
const EFTimelineItem = ({ feedback }) => {
    const [{}] = useTheme(stylesGenerator);
    const { translate } = useI18n();
    const [updateEFMutationState, updateEFMutationActions] = useUpdateEFMutation();
    const handleEdit = async () => {
        htmlEditorHelperActions.show({
            title: 'Edit Feedback',
            html: feedback.examinersFeedback?.data.feedback ?? '',
            async onSubmit(data) {
                if (!data.hasContent) {
                    return;
                }
                const reason = await promptHelperActions.show({
                    title: translate('Comments for the reviewer'),
                    placeholder: translate('Fixed a typo'),
                });
                if (!reason) {
                    return;
                }
                updateEFMutationActions.update({
                    variables: {
                        questionID: feedback.question.id,
                        data: {
                            feedback: data.html,
                            comments: reason,
                        },
                    },
                });
            },
        });
    };
    const [createEFMutationState, createEFMutationActions] = useCreateEFMutation();
    const handleAdd = () => {
        htmlEditorHelperActions.show({
            title: 'Add Feedback',
            html: '',
            onSubmit(data) {
                if (!data.hasContent) {
                    return;
                }
                createEFMutationActions.create({
                    variables: {
                        questionID: feedback.question.id,
                        data: {
                            feedback: data.html,
                        },
                    },
                });
            },
        });
    };
    return (React.createElement(EFView, { ...feedback, isAddLoading: createEFMutationState.loading, isEditLoading: updateEFMutationState.loading, onEdit: handleEdit, onAdd: handleAdd }));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default EFTimelineItem;
